import { frontendURL } from '../../../../helper/URLHelper';

const builders = accountId => ({
  parentNav: 'builders',
  routes: ['template_builders', 'flow_builders'],
  menuItems: [
    {
      icon: 'arrow-swap',
      label: 'CONTENT_TEMPLATE_BUILDER',
      key: 'templateBuilders',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/builders/template`),
      toStateName: 'template_builders',
    },
    // {
    //   key: 'flowBuilders',
    //   icon: 'sound-source',
    //   label: 'FLOW_BUILDER',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/builders/flow`),
    //   toStateName: 'flow_builders',
    // },
  ],
});

export default builders;
